
//Libraries
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingBar",
  props: {
    title: String,
  },
});
